import Payment from '@/models/read/Payment';

export default $axios => () => ({
    async getOrderPayments(order) {
        let payments = await this.getPayments(order.student.id);

        return payments.filter(payment => payment.id === order.id);
    },
    async getPayments(studentId) {
        let response = await $axios.$get(`/rest/finance/students/${studentId}/orders`);

        return response.data.map(payment => new Payment(payment));
    },
});
